const yearMin = 2015
const yearMax = 2040
const years = [{label:'Seleccionar...', value:''}]

for(let i = yearMin; i <= yearMax; i++){
    years.push({label:i,  value: i})
}

export const optionsYears = ()=> years